import { InputsHelper } from '../lib/inputs_helper';


$(function() {
  InputsHelper.mask_country_code_of_mobile_phone();
  return InputsHelper.mask_ssn_number();
});
  